
import { useState, useEffect, useRef } from 'react';
import { fetchMountainRoads } from '../services/overpassService';
import { MountainRoad, MapBounds } from '../types';
import { boundsOverlapRatio } from '../utils/boundsUtils';

export const useMountainRoads = (
  active: boolean,
  zoom: number,
  currentViewBounds: MapBounds | null
) => {
  const [roads, setRoads] = useState<MountainRoad[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const lastFetchedBoundsRef = useRef<MapBounds | null>(null);

  useEffect(() => {
    if (!active || zoom < 9 || !currentViewBounds) {
      if (!active) { setRoads([]); setError(false); lastFetchedBoundsRef.current = null; }
      return;
    }

    if (lastFetchedBoundsRef.current && boundsOverlapRatio(lastFetchedBoundsRef.current, currentViewBounds) > 0.7) {
      return;
    }

    const loadRoads = async () => {
      setIsLoading(true);
      try {
        const data = await fetchMountainRoads(currentViewBounds);
        setRoads(data);
        setError(false);
        lastFetchedBoundsRef.current = currentViewBounds;
      } catch (err) {
        console.error("Failed to load mountain roads:", err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    const timer = setTimeout(loadRoads, 1000);
    return () => clearTimeout(timer);
  }, [currentViewBounds, active, zoom]);

  return { roads, isLoading, error };
};
